import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Meta from '../components/ui/Meta'; // Import the new Meta component
import { Helmet } from 'react-helmet'; // Keep Helmet for Schema.org scripts

function BlogPostPage() {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch(`/api/blog_posts?slug=${slug}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setPost(data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);

  if (loading) {
    return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">Yükleniyor...</div>;
  }

  if (error || !post) {
    return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">Hata: Yazı bulunamadı.</div>;
  }

  const postSchema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://ibrahimlevent.com.tr/blog/${post.slug}`
    },
    "headline": post.title,
    "image": `https://ibrahimlevent.com.tr${post.image_url}`,
    "datePublished": new Date(post.created_at).toISOString(),
    "dateModified": new Date(post.updated_at).toISOString(),
    "author": {
      "@type": "Person",
      "name": "İbrahim Levent"
    },
    "publisher": {
      "@type": "Organization",
      "name": "İbrahim Levent",
      "logo": {
        "@type": "ImageObject",
        "url": "https://ibrahimlevent.com.tr/logo512.png"
      }
    },
    "description": post.meta_description || post.content.replace(/<[^>]*>?/gm, '').substring(0, 160)
  };

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-900 text-white py-12 lg:py-20">
        <Meta
          title={`${post.title} - İbrahim Levent`}
          description={post.meta_description || post.content.replace(/<[^>]*>?/gm, '').substring(0, 160)}
          keywords={post.meta_keywords}
          canonicalUrl={`https://ibrahimlevent.com.tr/blog/${post.slug}`}
        />
        <Helmet> {/* Keep Helmet for Schema.org scripts */}
          <script type="application/ld+json">{JSON.stringify(postSchema)}</script>
        </Helmet>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <article className="bg-gray-800/50 backdrop-blur-sm rounded-xl border border-gray-700/50 p-6 shadow-lg">
            <header className="mb-8 text-center">
              <h1 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">{post.title}</h1>
              <p className="text-gray-400 text-sm">Yayınlanma Tarihi: {new Date(post.created_at).toLocaleDateString()}</p>
              {post.image_url && (
                <img src={post.image_url} alt={post.title} className="w-full max-w-xl mx-auto h-auto object-cover rounded-xl mt-6" />
              )}
            </header>
            <div 
              className="prose prose-invert prose-lg max-w-none mx-auto text-gray-300 break-words"
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
          </article>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default BlogPostPage;